export const getDevicePixelRatio = (): number => window.devicePixelRatio || 1;

export const getCanvasContext = (
  canvas: HTMLCanvasElement,
  errorMessage = 'Failed to get 2D context'
): CanvasRenderingContext2D => {
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error(errorMessage);
  }
  return ctx;
};

export const resizeCanvas = (
  canvas: HTMLCanvasElement,
  ctx: CanvasRenderingContext2D,
  width: number,
  height: number,
  dpr = getDevicePixelRatio()
): void => {
  canvas.width = width * dpr;
  canvas.height = height * dpr;
  canvas.style.width = `${width}px`;
  canvas.style.height = `${height}px`;
  ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
};
